import * as Sentry from "@sentry/react";
import axios from "axios";

export const sendSentryError = (message: string) => {
  return Sentry.captureMessage(message);
};

export const logSentryUser = ({
  clientId,
  clientName,
  environment,
}: {
  clientId: string;
  clientName: string;
  environment: string;
}) => {
  Sentry.setUser({ id: clientId, userName: `${clientName}-${environment}` });
};

export const resetSentryUser = () => {
  Sentry.setUser(null);
};

export const setSentryContext = (params: Record<string, string>) => {
  Sentry.setContext("Bridge-Init", params);
};

export const sendAppVersionToSentry = async () => {
  let version = "1.0.0";
  try {
    const versionRes = await axios.get("/version.json");
    version = versionRes.data.version;
  } catch {
    // Do nothing
  }

  Sentry.setTag("appVersion", version);
};
